import React, { useContext } from "react";
// JavaScript library for creating Dropdown Selects
import Choices from "choices.js";
// reactstrap components
import {
  Alert,
  Button,
  Card,
  FormGroup,
  Form,
  Input,
  Table,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";

// Core Components
import MainNavbar from "components/navbars/MainNavbar";
import DemoFooter from "components/footers/DemoFooter.js";
import Upload from "components/upload/Upload.js";

import Footer from "components/footers/LandingFooter";

import { useHistory } from "react-router-dom";

import CID from "cids";
import { BigNumber, providers, utils } from "ethers";
import { hashSync } from "bcryptjs";
import * as Block from "multiformats/block";
import { sha256 } from "multiformats/hashes/sha2";
import * as dagCbor from "@ipld/dag-cbor"; // for decoding the signed payload
import * as dagJose from "dag-jose";
import {
  xc20pDirEncrypter,
  xc20pDirDecrypter,
  decryptJWE,
  createJWE,
  JWE,
} from "did-jwt";

import { decodeCleartext, prepareCleartext } from "dag-jose-utils";

import { create as createIpfs } from "ipfs";
import { convert as toLegacyIpld } from "blockcodec-to-ipld-format";
import { randomBytes } from "@stablelib/random";

import { makeStyles } from "@material-ui/core/styles";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";

import { requestUpdateAccount } from "../../api";
import IpfsContext from "../../IpfsContext";

import Popup from "../../components/headers/components/Popup";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 180,
  },
  container: {
    display: "flex",
  },
  paper: {
    margin: theme.spacing(1),
  },
  svg: {
    width: 100,
    height: 100,
  },
}));

function AccountSettings() {
  const [activeTab, setActiveTab] = React.useState("tab1");
  const history = useHistory();
  const [user, setUser] = React.useState(null);
  const [displayName, setDisplayName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [wallet, setWallet] = React.useState(null);
  const [walletType, setWalletType] = React.useState(null);
  const [buttonPopup, setButtonPopup] = React.useState(false);
  const [checked, setChecked] = React.useState(false);
  const [image, setImage] = React.useState("");
  const [identity, setIdentity] = React.useState([]);
  //const [ipfs, setIpfs] = React.useState([]);
  const ipfs = useContext(IpfsContext);
  const dagJoseIpldFormat = toLegacyIpld(dagJose);

  const classes = useStyles();

  React.useEffect(() => {
    /*
    async function setup() {
      // Instantiate an IPFS node, that knows how to deal with DAG-JOSE blocks
      if (ipfs.length < 1) {
        setIpfs(await createIpfs({ ipld: { formats: [dagJoseIpldFormat] } }));
      }
    }
    setup();
    */
  }, []);

  React.useEffect(() => {
    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
      const foundUser = JSON.parse(loggedInUser);
      setUser(foundUser);
      setDisplayName(foundUser.displayName);
      setEmail(foundUser.email);
      setWallet(foundUser.wallet);
      setWalletType(foundUser.walletType);
    } else {
      history.push("/login");
    }

    document.body.classList.add("account-settings");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("account-settings");
    };
  }, []);

  function updateIdentity(identity) {
    setIdentity(identity.pubKey);
  }

  const handleChange = () => {
    setChecked((prev) => !prev);
  };

  function onChangeWalletType(e) {
    const choice = e.target.value;
    setWalletType(choice.toLowerCase());
  }

  function PopupInside() {
    setChecked(true);
    setButtonPopup(true);
  }

  const storeEncrypted = async (payload, key) => {
    const dirEncrypter = xc20pDirEncrypter(key);
    // prepares a cleartext object to be encrypted in a JWE
    const cleartext = await prepareCleartext(payload);
    // encrypt into JWE container layout using secret key
    const jwe = await createJWE(cleartext, [dirEncrypter]);
    // let IPFS store the bytes using the DAG-JOSE codec and return a CID
    const cid = await ipfs.dag.put(jwe, {
      format: "dag-cbor",
      hashAlg: "sha2-256",
    });

    return cid;
  };
  const loadEncrypted = async (cid, key) => {
    const dirDecrypter = xc20pDirDecrypter(key);
    const retrieved = await ipfs.dag.get(cid);
    const decryptedData = await decryptJWE(retrieved.value, dirDecrypter);
    return decodeCleartext(decryptedData);
  };

  async function storeSigned(iden) {
    const key = randomBytes(32);

    var secretz = {
      email: email,
      displayName: displayName,
      wallet: wallet,
      profilePic: image,
      walletType: walletType,
    };

    //save profile pic

    if (image == "") {
      //if the user didnt upload an image
      if (user.profilePic != null || user.profilePic != undefined) {
        secretz.profilePic = user.profilePic;
      } else {
        secretz.profilePic = "";
      }
    }

    const cid = await storeEncrypted(secretz, iden.pubKey);

    const updatedAccountResponse = await requestUpdateAccount(
      wallet,
      cid.string
    );

    if (updatedAccountResponse.isSuccess) {
      const cid1 = new CID(updatedAccountResponse.payload.CID);

      const decoded = await loadEncrypted(cid1, iden.pubKey);

      await onSuccessfullLogin(decoded, "");
    } else {
      //setError(updatedAccountResponse.errorName);
    }
  }

  async function onSuccessfullLogin(user, token) {
    const stringUser = JSON.stringify(user);

    localStorage.setItem("user", stringUser);
    setUser(user);
  }

  const uploadImage = async (file) => {
    const base64 = await convertBase64(file);
    setImage(base64);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  return (
    <>
      <MainNavbar type="primary" />
      <div className="wrapper bg-secondary">
        <div className="section-shaped my-0 skew-separator skew-mini">
          <div className="page-header page-header-small"></div>
        </div>
        <div className="bg-white">
          <Card className="container bg-white mb-0">
            <Row>
              <Col md="3">
                <div className="section">
                  <section className="text-center">
                    {wallet != null && (
                      <Upload
                        avatar
                        uploadImage={uploadImage}
                        wallet={wallet}
                        profilePic={user.profilePic}
                        changeBtnColor="primary"
                        changeBtnClasses="btn-sm btn-round mt-3"
                        addBtnColor="primary"
                        addBtnClasses="btn-sm btn-round mt-3"
                        removeBtnClasses="btn-sm btn-round mt-1"
                      />
                    )}

                    <h3 className="title mt-4">{user && user.displayName}</h3>
                  </section>
                  <section>
                    <br></br>
                  </section>
                  <br></br>
                  <br></br>
                  <br></br>
                </div>
              </Col>
              <Col className="ml-auto" md="8">
                <div className="section">
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="tab1">
                      <div>
                        <header>
                          <h2 className="text-uppercase">
                            General information
                          </h2>
                        </header>
                        <hr className="line-primary"></hr>
                        <br></br>
                        <Row>
                          <Col className="align-self-center" md="3">
                            <label className="labels" htmlFor="#wallet">
                              Wallet
                            </label>
                          </Col>
                          <Col className="align-self-center" md="9">
                            <p>{wallet}</p>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="align-self-center" md="3">
                            <label className="labels" htmlFor="#walletType">
                              Wallet type
                            </label>
                          </Col>
                          <Col className="align-self-center" md="9">
                            <FormGroup>
                              <Input
                                data-trigger=""
                                id="wallet-type"
                                name="wallet-type"
                                type="select"
                                value={walletType}
                                onChange={onChangeWalletType}
                                placeholder={"Select Wallet"}
                                defaultValue=""
                              >
                                <option hidden value="">
                                  Select Wallet
                                </option>
                                <option value="metamask">Metamask</option>
                                <option value="fortmatic">Fortmatic</option>
                              </Input>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="align-self-center" md="3">
                            <label className="labels" htmlFor="#displayName">
                              Display Name
                            </label>
                          </Col>
                          <Col className="align-self-center" md="9">
                            <FormGroup>
                              <Input
                                id="displayName"
                                name="displayName"
                                required="required"
                                type="text"
                                value={displayName}
                                onChange={(event) =>
                                  setDisplayName(event.target.value)
                                }
                              ></Input>
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col className="align-self-center" md="3">
                            <label className="labels" htmlFor="#email">
                              Email
                            </label>
                          </Col>
                          <Col className="align-self-center" md="9">
                            <FormGroup>
                              <Input
                                id="email"
                                name="email"
                                required="required"
                                type="email"
                                value={email}
                                onChange={(event) =>
                                  setEmail(event.target.value)
                                }
                              ></Input>
                            </FormGroup>
                          </Col>
                        </Row>

                        {/*
                        <Row>
                          <Col className="align-self-center" md="3">
                            <label className="labels" htmlFor="#phone">
                              Phone Number
                            </label>
                          </Col>
                          <Col className="align-self-center" md="4">
                            <FormGroup>
                              <Input
                                placeholder="(111)-123-4567"
                                id="phone"
                                name="phone"
                                required="required"
                                type="tel"
                              ></Input>
                            </FormGroup>
                          </Col>
                        </Row>
                          */}
                        <Row className="mt-5">
                          <Col md="6">
                            <Button
                              color="primary"
                              type="submit"
                              onClick={PopupInside}
                              onChange={handleChange}
                              checked={checked}
                            >
                              Save Changes
                            </Button>
                            <Button
                              color="primary"
                              outline
                              type="reset"
                              onClick={async () => {
                                await setEmail(user.email);
                                await setDisplayName(user.displayName);
                              }}
                            >
                              Cancel
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </TabPane>
                    <TabPane tabId="tab2">
                      <header>
                        <h2 className="text-uppercase">Billing method</h2>
                      </header>
                      <hr className="line-primary"></hr>
                      <br></br>
                      <Table className="align-items-center">
                        <thead>
                          <tr>
                            <th scope="col">Card Type</th>
                            <th scope="col">Card Number</th>
                            <th scope="col">Payment Method</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                      </Table>
                      <Button color="primary" size="sm">
                        <i className="tim-icons icon-simple-add"></i>
                        Add card
                      </Button>
                    </TabPane>
                    <TabPane tabId="tab3">
                      <div className="g-pos-rel h-100 g-brd-around g-brd-gray-light-v7 g-rounded-4 g-pa-15 g-pa-30--md">
                        <header>
                          <h2 className="text-uppercase g-font-size-12 g-font-size-default--md g-color-black mb-0">
                            Security Questions
                          </h2>
                        </header>
                        <hr className="line-primary"></hr>
                        <Form>
                          <Row>
                            <Col md="6">
                              <label>Security Question</label>
                              <FormGroup>
                                <Input
                                  data-trigger=""
                                  id="choices-single-default-6"
                                  name="choices-single-default-6"
                                  type="select"
                                >
                                  <option disabled>Your Question</option>
                                  <option defaultValue="2">Question 1</option>
                                  <option defaultValue="3">Question 2</option>
                                  <option defaultValue="4">Question 3</option>
                                </Input>
                              </FormGroup>
                            </Col>
                            <Col md="6">
                              <label>Your Answer</label>
                              <FormGroup>
                                <Input
                                  placeholder="Enter your answer"
                                  type="text"
                                ></Input>
                              </FormGroup>
                            </Col>
                          </Row>
                          <br></br>
                          <br></br>
                          <header>
                            <h2 className="text-uppercase">
                              Security Settings
                            </h2>
                          </header>
                          <hr className="line-primary"></hr>
                          <FormGroup className="d-flex align-items-center justify-content-between">
                            <span>Notify me via email when logging in</span>
                            <label className="custom-toggle">
                              <input type="checkbox"></input>
                              <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="OFF"
                                data-label-on="ON"
                              ></span>
                            </label>
                          </FormGroup>
                          <FormGroup className="d-flex align-items-center justify-content-between">
                            <span>
                              Send SMS confirmation for all online payments
                            </span>
                            <label className="custom-toggle">
                              <input defaultChecked type="checkbox"></input>
                              <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="OFF"
                                data-label-on="ON"
                              ></span>
                            </label>
                          </FormGroup>
                          <FormGroup className="d-flex align-items-center justify-content-between">
                            <span>
                              Check which devices accessed your account
                            </span>
                            <label className="custom-toggle">
                              <input type="checkbox"></input>
                              <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="OFF"
                                data-label-on="ON"
                              ></span>
                            </label>
                          </FormGroup>
                          <FormGroup className="d-flex align-items-center justify-content-between">
                            <span>
                              Find My Device, make sure your device can be found
                              if it gets lost
                            </span>
                            <label className="custom-toggle">
                              <input defaultChecked type="checkbox"></input>
                              <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="OFF"
                                data-label-on="ON"
                              ></span>
                            </label>
                          </FormGroup>
                          <FormGroup className="d-flex align-items-center justify-content-between">
                            <span>
                              Lock your device with a PIN, pattern, or password
                            </span>
                            <label className="custom-toggle">
                              <input defaultChecked type="checkbox"></input>
                              <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="OFF"
                                data-label-on="ON"
                              ></span>
                            </label>
                          </FormGroup>
                          <FormGroup className="d-flex align-items-center justify-content-between">
                            <span>
                              Manage what apps have access to app-usage data on
                              your device
                            </span>
                            <label className="custom-toggle">
                              <input type="checkbox"></input>
                              <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="OFF"
                                data-label-on="ON"
                              ></span>
                            </label>
                          </FormGroup>
                          <Row className="mt-5 justify-content-end">
                            <Col className="actions" md="4">
                              <Button
                                color="primary"
                                outline
                                size="sm"
                                type="reset"
                              >
                                Cancel
                              </Button>
                              <Button color="primary" size="sm" type="button">
                                Save Changes
                              </Button>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    </TabPane>
                    <TabPane tabId="tab4">
                      <Container>
                        <Row>
                          <Col xs="12">
                            <Alert className="text-small" color="primary">
                              <i className="icon-shield"></i>
                              <span>
                                We will never distribute your email address to
                                third parties. Read about email communication in
                                our privacy policy.
                              </span>
                            </Alert>
                          </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                          <Col xs="12">
                            <Form>
                              <h5 className="mb-4">Notification Preferences</h5>
                              <div className="custom-control custom-checkbox mb-3">
                                <input
                                  className="custom-control-input"
                                  defaultChecked
                                  id="notification1"
                                  type="checkbox"
                                ></input>
                                <label
                                  className="custom-control-label"
                                  htmlFor="notification1"
                                >
                                  <span>Someone mentions me</span>
                                </label>
                              </div>
                              <div className="custom-control custom-checkbox mb-3">
                                <input
                                  className="custom-control-input"
                                  defaultChecked
                                  id="notification2"
                                  type="checkbox"
                                ></input>
                                <label
                                  className="custom-control-label"
                                  htmlFor="notification2"
                                >
                                  <span>Someone follows me</span>
                                </label>
                              </div>
                              <div className="custom-control custom-checkbox mb-3">
                                <input
                                  className="custom-control-input"
                                  id="notification3"
                                  type="checkbox"
                                ></input>
                                <label
                                  className="custom-control-label"
                                  htmlFor="notification3"
                                >
                                  <span>Someone shares my activty</span>
                                </label>
                              </div>
                              <div className="custom-control custom-checkbox mb-3">
                                <input
                                  className="custom-control-input"
                                  id="notification4"
                                  type="checkbox"
                                ></input>
                                <label
                                  className="custom-control-label"
                                  htmlFor="notification4"
                                >
                                  <span>Someone messages me</span>
                                </label>
                              </div>
                              <div className="custom-control custom-checkbox mb-3">
                                <input
                                  className="custom-control-input"
                                  id="notification5"
                                  type="checkbox"
                                ></input>
                                <label
                                  className="custom-control-label"
                                  htmlFor="notification5"
                                >
                                  <span>Someone adds me to a project</span>
                                </label>
                              </div>
                              <div className="custom-control custom-checkbox mb-3">
                                <input
                                  className="custom-control-input"
                                  id="notification6"
                                  type="checkbox"
                                ></input>
                                <label
                                  className="custom-control-label"
                                  htmlFor="notification6"
                                >
                                  <span>Sales and promotions</span>
                                </label>
                              </div>
                              <Button
                                className="mt-3 mb-5"
                                color="primary"
                                size="sm"
                                type="submit"
                              >
                                Update preferences
                              </Button>
                            </Form>
                          </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                          <Col xs="12">
                            <Form>
                              <h5>Notification Frequency</h5>
                              <div className="custom-control custom-radio mb-3">
                                <input
                                  className="custom-control-input"
                                  id="freq1"
                                  name="custom-radio-1"
                                  type="radio"
                                ></input>
                                <label
                                  className="custom-control-label"
                                  htmlFor="freq1"
                                >
                                  <span>Daily</span>
                                </label>
                              </div>
                              <div className="custom-control custom-radio mb-3">
                                <input
                                  className="custom-control-input"
                                  id="freq2"
                                  name="custom-radio-1"
                                  type="radio"
                                ></input>
                                <label
                                  className="custom-control-label"
                                  htmlFor="freq2"
                                >
                                  <span>Weekly</span>
                                </label>
                              </div>
                              <div className="custom-control custom-radio mb-3">
                                <input
                                  className="custom-control-input"
                                  id="freq3"
                                  name="custom-radio-1"
                                  type="radio"
                                ></input>
                                <label
                                  className="custom-control-label"
                                  htmlFor="freq3"
                                >
                                  <span>Monthly</span>
                                </label>
                              </div>
                              <div className="custom-control custom-radio mb-3">
                                <input
                                  className="custom-control-input"
                                  defaultChecked
                                  id="freq4"
                                  name="custom-radio-1"
                                  type="radio"
                                ></input>
                                <label
                                  className="custom-control-label"
                                  htmlFor="freq4"
                                >
                                  <span>Never</span>
                                </label>
                              </div>
                              <Button
                                className="mt-3"
                                color="primary"
                                size="sm"
                                type="submit"
                              >
                                Update
                              </Button>
                            </Form>
                          </Col>
                        </Row>
                      </Container>
                    </TabPane>
                  </TabContent>
                  <Grow in={checked}>
                    <Paper elevation={4} className={classes.paper}>
                      <Popup
                        trigger={buttonPopup}
                        setTrigger={setButtonPopup}
                        setIdentityPop={updateIdentity}
                        Change={storeSigned}
                        pageType="updateInfo"
                      />
                    </Paper>
                  </Grow>
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AccountSettings;
